// extracted by mini-css-extract-plugin
export default {"wrapper":"SideMenuComponent_wrapper__G17oc","hidden":"SideMenuComponent_hidden__SCQI6","header":"SideMenuComponent_header__BYvAb"};